import React, { useEffect, useState } from 'react'
import RootNavigator from '@routers/RootNavigator/RootNavigator'
import { useAuth } from '@context/AuthContext/AuthContext'
import { handleMobileRedirect, AppProviders } from '@utils/setup/setup'
import { initializeSecrets } from '@utils/initializeSecrets'
import { initializeGeocode, requireSecret } from '@utils/secrets'
import './App.css'
import { functions } from './utils/firebase'

const App: React.FC = () => {
  const { setQueryParams } = useAuth()

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    setQueryParams(urlParams)

    // functions.useEmulator('localhost', 5001) //testing
  }, [setQueryParams])

  return <RootNavigator />
}

const AppWrapper: React.FC = () => {
  const [secretsReady, setSecretsReady] = useState(false)

  useEffect(() => {
    const init = async () => {
      try {
        await initializeSecrets()
        await initializeGeocode()
      } catch (error) {
        console.error('[AppWrapper] Error during secrets initialization:', error)
      } finally {
        setSecretsReady(true)
      }
    }
    init()
  }, [])

  if (handleMobileRedirect() === 'redirected') {
    return null
  }

  if (!secretsReady) {
    return <div>Loading...</div>
  }

  let publishableKey: string
  try {
    publishableKey = requireSecret('STRIPE_PUBLISHABLE_KEY')
  } catch (e) {
    console.error('[AppWrapper] requireSecret failed:', e)
    throw e
  }

  return (
    <AppProviders stripePublishableKey={publishableKey}>
      <App />
    </AppProviders>
  )
}

export default AppWrapper
